
// Auth Types
export const AUTH_USER = "auth_user";
export const AUTH_UPDATE = "auth_update";
export const AUTH_ERROR = "auth_error";
export const AUTH_FORGOT_PASS = "auth_forgot_password";
export const AUTH_RESET_PASS = "auth_reset_password";
export const AUTH_CHANGE_PASS = "auth_change_password";
export const AUTH_CLEAR_MSG = "auth_clear_message";

